import { alpha, darken } from '@mui/material/styles'
import type { SxProps, Theme } from '@mui/material/styles'
import { AppPalette } from '@/theme/themes/colors'

const buttonSize = {
  typography: 'smallSemibold',
  minHeight: (theme: Theme) => theme.spacing(5),
  px: 2.5,
  borderRadius: '8px',
  textTransform: 'none',
  boxShadow: 'none',
  transition: 'all 0.15s ease',
  '& .MuiSvgIcon-root': { color: 'inherit' },
}

export const stationDeletionDangerButtonSx = {
  ...buttonSize,
  bgcolor: AppPalette.RED.main,
  color: AppPalette.NEUTRAL.white,
  '&:hover': {
    bgcolor: darken(AppPalette.RED.main, 0.12),
    color: AppPalette.NEUTRAL.white,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    bgcolor: alpha(AppPalette.RED.main, 0.16),
    color: 'text.main',
    opacity: 0.6,
    boxShadow: 'none',
  },
} satisfies SxProps<Theme>

export const stationDeletionSecondaryButtonSx = {
  ...buttonSize,
  bgcolor: 'transparent',
  color: 'text.main',
  borderColor: 'border.main',
  '&:hover': {
    bgcolor: 'action.hover',
    color: 'text.main',
    borderColor: 'text.main',
  },
  '&.Mui-disabled': {
    bgcolor: 'action.disabledBackground',
    color: 'text.main',
    opacity: 0.6,
    boxShadow: 'none',
  },
} satisfies SxProps<Theme>

export const stationDeletionAlertSx = {
  typography: 'smallRegular',
  borderRadius: '10px',
  lineHeight: 1.5,
  color: 'text.main',
  bgcolor: (theme: Theme) => alpha(theme.palette.error.light, 0.08),
  borderColor: 'error.light',
  boxShadow: 'none',
  '& .MuiAlert-icon .MuiSvgIcon-root': { color: 'error.light' },
  '& .MuiAlert-message': { overflowWrap: 'anywhere' },
} satisfies SxProps<Theme>
